const getProductsFromAggregatorData = (immAggregatorData) => {
    if (!immAggregatorData || !immAggregatorData.getIn(['data', 'products'])) return []
    
    return Object.values(immAggregatorData.getIn(['data', 'products']).toJS())
}

export default getProductsFromAggregatorData;
